import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sokusai.constants';

@Component({
  selector: 'app-sokusai-change-password-sent',
  templateUrl: './sokusai-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sokusai-change-password-sent.component.css',
  ],
})
export class SokusaiChangePasswordSentComponent implements OnInit {
  email: string | null = null;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
